import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LOGO_URL, formatApiErrorDetail } from "../../lib/api";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav("/admin");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-blush flex items-center justify-center px-5">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_URL} alt="Nails Renss" className="h-20 w-20 rounded-full shadow-sm mb-4" />
          <h1 className="font-display text-3xl font-semibold text-brand-charcoal">Nails Renss Beheer</h1>
          <p className="text-brand-muted text-sm mt-1 flex items-center gap-1.5"><Lock size={13} /> Beveiligde omgeving</p>
        </div>

        <form onSubmit={submit} className="bg-white rounded-3xl border border-brand-border p-7 shadow-sm space-y-4" data-testid="admin-login-form">
          <div>
            <label className="block text-sm font-medium text-brand-charcoal mb-1.5">E-mailadres</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email-input" className="w-full rounded-2xl border border-brand-border px-4 py-3 focus:border-brand-pink focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-brand-charcoal mb-1.5">Wachtwoord</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password-input" className="w-full rounded-2xl border border-brand-border px-4 py-3 focus:border-brand-pink focus:outline-none" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} className="w-full bg-brand-charcoal text-white font-semibold py-3.5 rounded-full disabled:opacity-60 flex items-center justify-center gap-2" data-testid="admin-login-submit-button">
            {loading ? <Loader2 className="animate-spin" size={18} /> : null} Inloggen
          </button>
        </form>
        <a href="/" className="block text-center mt-6 text-sm text-brand-muted hover:text-brand-charcoal">← Terug naar website</a>
      </div>
    </div>
  );
}
